import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getTeams } from "../../actions/userActions/teamAction";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import SearchInput from "../subComponents/search/SearchInput";

import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import AddTeams from "./AddTeams";

function Teams() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1)
  const [previousQuery, setPreviousQuery] = useState("");
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [teamdata, setteamdata] = useState([]);
  const teams = useSelector((state) => state.teams_reducer.teams);
  const teamsData = teams && teams.result;
   const totalPages = teams?.totalPages || 0;
  const totalItems = teams?.totalCount || 0;
  const itemsPerPage = 10;
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  useEffect(() => {
    const pageNumber = currentPage;
  
      if (query !== previousQuery) {
        setCurrentPage(1);
      }
      dispatch(getTeams(pageNumber, itemsPerPage, query));
      setPreviousQuery(query);
  
    }, [currentPage, query]);
  
  const handlePageChange = (page) => {
    setCurrentPage(page);
    history.push(`?page=${page}&search=${query}`);
  };
  useEffect(() => {
  
    const teamData = teams && teamsData;
    const TeamData = teamData?.map((teams) => ({
      ...teams,
      status: (
        <span
          style={{
            background: "#4361FF1A",
            width: "56px",
            height: "26px",
            padding: "3px 8px",
            display: "inline-block",
            textAlign: "center",
            lineHeight: "20px",
            borderRadius: "4px 0px 0px 0px",
            opacity: 1 ,
          }}
        >
          {teams.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setteamdata(TeamData);
  }, [teams]);

  const columns = [
    { label: "Name", accessor: "name" },
    { label: "Description", accessor: "description" },
     { label: "Status", accessor: "status" },  
  ];
  
  const handleAddTeamClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditTeam = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
    dispatch(getTeams(currentPage, itemsPerPage, query));
    setShowModal(false);
  };
  const actions = [  
    {
        label: 'Edit Team',
        icon: <EditOutlinedIcon />,
        permission: 'CanUpdateTeam',
        handler:handleEditTeam,
    },
];

const handleSearchChange = (e) => {
  setQuery(e.target.value);
  setCurrentPage(1);
  history.push(`?page=${page}&search=${query}`);
};
  return (
    <>
      <div>
      <div className="main-container">
            <div className="content-header">
                <div className="header-navigation">
                    <BodySmallMedium text="Manage" color="#A1A2A4" />
                    <img
                        src={chevron_rightIcon} alt="Chevron Right" className="chevron-right-icon" />
                    <BodySmallMedium text="Teams" color="#1E293B" />
                </div>
            </div>
            <Heading6Regular text="Teams" color="#1E293B" />
            <div className="content-wrapper">
                <div className="pagination">
                <SearchInput
              placeholder="Search"
              onChange={handleSearchChange}
              value={query}
            />
                    <div style={{ display: "flex", alignItems: "center" }}>
                     
                        <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                     
                        {permissions && permissions.includes("CanAddTeam") && (
                            <CustomButton text="Add Team" width="180px" onClick={handleAddTeamClick} />
                        )}
                    </div>
                </div>
                <DynamicTable
                    data={ teamdata}
                    isLoading={teams === "isLoading"}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                />
                     <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
    {totalItems > 0 && (
      <CustomPagination
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
      />
    )}
    </div>
            </div>

        </div>
        {showModal && (
        <AddTeams
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
      </div>
   
    </>
  );
}

export default Teams;
